import React from "react";

import empty from "../../assets/empty.png";

const EmptyScreen = ({ text }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ height: "50vh" }}
    >
      <img src={empty} alt="" height={200} />
      <div className="fs-7 fw-bold">{text}</div>
    </div>
  );
};

export default EmptyScreen;
